import { TTTSectionSubTitle } from "../../TeachersToolkitTraining.styled";
import { downloadFile } from "./TTTElement.utils";
import React, { Fragment, useState } from "react";
import { PlayIcon } from "./icons/PlayIcon";
import { DocIcon } from "./icons/DocIcon";
import {
  TTTElementTitleContainer,
  TTTElementImageContainer,
  TTTElementIconContainer,
  TTTElementContainer,
} from "./TTTElement.styled";
import {
  DialogContentText,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@material-ui/core";

/**
 *
 * @param props.type "video" | "document"
 * @param props.resource object
 */
export const TTTElement = ({ type, resource }) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    if (type === "video") {
      setOpen(true);
    } else {
      const splitURL = window.location.href.split("/");
      const baseURL = splitURL.slice(0, 3).join("/");
      downloadFile(baseURL + resource.url, resource.title);
    }
  };

  return (
    <Fragment>
      <TTTElementContainer onClick={handleClick}>
        <TTTElementImageContainer>
          <img src={resource.thumbnailPath} />
          <TTTElementIconContainer className="ttt-icon-container">
            {type === "video" ? <PlayIcon /> : <DocIcon />}
          </TTTElementIconContainer>
        </TTTElementImageContainer>
        <TTTElementTitleContainer>
          <TTTSectionSubTitle
            align="center"
            color="primary"
            className="ttt-title"
          >
            {resource.title}
          </TTTSectionSubTitle>
        </TTTElementTitleContainer>
      </TTTElementContainer>
      {type === "video" && (
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{resource.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{resource.description}</DialogContentText>
            <iframe
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              src={resource.url}
              frameBorder="0"
              allowFullScreen
              width="560"
              height="350"
            />
          </DialogContent>
        </Dialog>
      )}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/components/TTTElement/TTTElement.js